import type { Playbook, Offer } from "../types";

const offer = (o: Omit<Offer, "sendsPrompt"> & Partial<Pick<Offer, "sendsPrompt">>): Offer => o;

export const calendarPlaybooks: Playbook[] = [
  {
    app: "calendar",
    priority: 80,
    match: (s) =>
      s.surface === "event" && s.item_id && s.facts?.is_invitation
        ? offer({
            key: "calendar.event.rsvp",
            app: "calendar",
            titleKey: "assistant.mochi.offers.calendar.rsvp.title",
            bodyKey: "assistant.mochi.offers.calendar.rsvp.body",
            ctaKey: "assistant.mochi.offers.calendar.rsvp.cta",
            promptKey: "assistant.mochi.offers.calendar.rsvp.prompt",
            promptVars: { item_id: s.item_id },
          })
        : null,
  },
  {
    app: "calendar",
    priority: 70,
    match: (s) =>
      s.surface === "event" && s.item_id
        ? offer({
            key: "calendar.event.prep",
            app: "calendar",
            titleKey: "assistant.mochi.offers.calendar.prep.title",
            bodyKey: "assistant.mochi.offers.calendar.prep.body",
            ctaKey: "assistant.mochi.offers.calendar.prep.cta",
            promptKey: "assistant.mochi.offers.calendar.prep.prompt",
            promptVars: { item_id: s.item_id },
          })
        : null,
  },
  {
    app: "calendar",
    priority: 60,
    match: (s) =>
      s.surface === "event-create" && s.facts?.title_empty
        ? offer({
            key: "calendar.create.title",
            app: "calendar",
            titleKey: "assistant.mochi.offers.calendar.title.title",
            bodyKey: "assistant.mochi.offers.calendar.title.body",
            ctaKey: "assistant.mochi.offers.calendar.title.cta",
            promptKey: "assistant.mochi.offers.calendar.title.prompt",
          })
        : null,
  },
  {
    app: "calendar",
    priority: 10,
    match: (s) =>
      s.surface === "calendar"
        ? offer({
            key: "calendar.create.help",
            app: "calendar",
            titleKey: "assistant.mochi.offers.calendar.help.title",
            bodyKey: "assistant.mochi.offers.calendar.help.body",
            ctaKey: "assistant.mochi.offers.calendar.help.cta",
            promptKey: "assistant.mochi.offers.calendar.help.prompt",
          })
        : null,
  },
];
